module.exports = __webpack_public_path__ + "static/media/Imagen_5.60037787.jpg";